import { IAIPlannerUIState } from '@bridebook/web/lib/ai-planner/types';
import { AIPlannerUIStorage } from '@bridebook/web/lib/storage-manager/basic';

export const readUIState = (): IAIPlannerUIState => {
  try {
    return AIPlannerUIStorage.get() ?? {};
  } catch {
    try {
      AIPlannerUIStorage.remove();
    } catch {
      // remove() throws too when storage itself is blocked
    }
    return {};
  }
};

// Merged, not replaced, so writing one field keeps the others.
export const writeUIState = (state: IAIPlannerUIState) =>
  AIPlannerUIStorage.set({ ...readUIState(), ...state });
